import { TablizoSchema } from "Components/LabIZO/Tablizo";

const Errors = [
  // {
  //   label: "#",
  //   name: "idx",
  //   width: 100
  // },
  {
    label: "Error",
    name: "error",
  },
  {
    label: "FAQ ID",
    name: "faq",
    width: 200,
  },
];

const Update: TablizoSchema[] = [
  {
    label: "FAQ ID",
    name: "id",
    width: 200,
  },
  {
    label: "(EN) +",
    name: "intent.EN.add",
    width: 100,
  },

  {
    label: "(TC) +",
    name: "intent.TC.add",
    width: 100,
  },

  {
    label: "(SC) +",
    name: "intent.SC.add",
    width: 100,
  },

  {
    label: "Answer Update (EN)",
    name: "answer.EN.new",
  },
  {
    label: "Answer Update (TC)",
    name: "answer.TC.new",
  },
  {
    label: "Answer Update (SC)",
    name: "answer.SC.new",
  },
  {
    label: "New Quick Reply ",
    name: "quickReply.new",
  },
  {
    label: "Updated Quick Reply ",
    name: "quickReply.updated",
  },
  {
    label: "New Suggested Questions",
    name: "followingIntent.new",
  },
  {
    label: "Updated Suggested Questions ",
    name: "followingIntent.updated",
  },
];

const UpdateExpire: TablizoSchema[] = [
  {
    label: "FAQ ID",
    name: "id",
    width: 200,
  },
  {
    label: "Enable",
    name: "expiriable.enable",
  },
  {
    label: "Enable from",
    name: "expiriable.from",
  },
  {
    label: "Enable to",
    name: "expiriable.to",
  },
  {
    label: "Answer Update (EN)",
    name: "expiriable.text.EN.new",
  },
  {
    label: "Answer Update (TC)",
    name: "expiriable.text.TC.new",
  },
  {
    label: "Answer Update (SC)",
    name: "expiriable.text.SC.new",
  },
  {
    label: "New Quick Reply ",
    name: "quickReplyPromo.new",
  },
  {
    label: "Updated Quick Reply ",
    name: "quickReplyPromo.updated",
  },
];

const New = [
  // {
  //   label: "#",
  //   name: "idx",
  //   width: 100,
  // },
  {
    label: "FAQ ID",
    name: "id",
    width: 200,
  },
  {
    label: "Question Sample",
    name: "intent.EN.first",
  },
  {
    label: "EN",
    name: "intent.EN.length",
    width: 100,
  },
  {
    label: "TC",
    name: "intent.TC.length",
    width: 100,
  },
  {
    label: "SC",
    name: "intent.SC.length",
    width: 100,
  },
  {
    label: "Answer Sample",
    name: "answer.EN.first",
  },
  {
    label: "EN",
    name: "answer.EN.length",
    width: 100,
  },
  {
    label: "TC",
    name: "answer.TC.length",
    width: 100,
  },
  {
    label: "SC",
    name: "answer.SC.length",
    width: 100,
  },
  {
    label: "New Quick Reply ",
    name: "quickReply.new",
  },
  {
    label: "New Suggested Questions",
    name: "followingIntent.new",
  },
];

const Warnings = [
  {
    label: "Error",
    name: "error",
  },
  {
    label: "FAQ ID",
    name: "faq",
    width: 200,
  },
];

const schema = {
  Errors,
  Update,
  UpdateExpire,
  New,
  Warnings,
};

export default schema;
